<template>
    <div class="wl-left-aside">
        <div class="card-title"><i class="el-icon-caret-right" style="color: #EF8200;"></i> 收货站点</div>
        <CustomElScrollbar style="height: calc(100% - 40px);">
            <SiteItem v-for="item in siteList" :key="item.id" :data="item"
                :statisticsInfo="statisticsMap ? statisticsMap[item.id] : {}"
                :class="item.id === currentSiteId ? 'is-active' : ''" @click="handleSiteClick(item)">
            </SiteItem>
            <el-empty v-if="siteList.length === 0" description="当前配送站还没开通收货站点">
                <div slot="image"></div>
            </el-empty>
        </CustomElScrollbar>

    </div>
</template>

<script>
import SiteApi from '@/page/business/wuliu/api/site';
import SiteItem from './SiteItem.vue';
import CustomElScrollbar from '@/components/custom-el-scrollbar/CustomElScrollbar.vue';

export default {
    components: {
        SiteItem,
        CustomElScrollbar,
    },
    props: {
        /**
         * 配送站ID
         */
        startSiteId: {
            type: String,
            default: '',
        },
    },

    data() {
        return {
            siteList: [],
            currentSiteId: '',
            oldCurrentSiteId: '', // 上一个选中站点id，用于判断是否需要重置当前选中站点
            timerId: null,
            statisticsMap: {}, // 站点统计信息map，key为站点id，value为统计信息对象
        };
    },
    computed: {},
    methods: {
        /**
        * 获取收货站点列表
        */
        getSiteList() {
            if (!this.startSiteId) return;

            SiteApi.fetchServiceSiteList(this.startSiteId).then((res) => {
                if (res.code == 200) {
                    this.siteList = res.rows || res.data || [];

                    if (this.siteList.length > 0) {
                        this.handleSiteClick(this.siteList[0]);
                    }
                }
            });
        },
        /**
     * 获取统计信息
     *
     * @returns {void} 无返回值
     */
        getStatistics() {
            if (!this.startSiteId) return;
            SiteApi.fetchSiteAllStatistics(this.startSiteId).then((res) => {

                let statisticsMap = {};
                if (res.code == 200) {
                    let data = res.data || [];
                    data.forEach((item) => {
                        statisticsMap[item.id] = item;
                    });
                }
                this.statisticsMap = statisticsMap;
            });
        },
        handleSiteClick(item) {
            this.oldCurrentSiteId = this.currentSiteId;
            this.currentSiteId = item.id;
            this.$emit('selectSite', item);
        },
        resetCurrentSite() {
            this.currentSiteId = this.oldCurrentSiteId;
        },
        initTimer() {
            clearInterval(this.timerId);
            this.getStatistics();
            this.timerId = setInterval(() => {
                this.getStatistics();
            }, 1000 * 60);
        },
    },
    mounted() {
        this.getSiteList();
        this.initTimer();
    },
    beforeDestroy() {
        if (this.timerId) {
            clearInterval(this.timerId);
        }
    },
    watch: {
        startSiteId(newVal, oldVal) {
            if (newVal) {
                this.getSiteList();
                this.initTimer();
            }
        },
    },
};
</script>

<style lang="scss" scoped>
$bgColor: #0D1541;
$bgColor2: #0D134F;
$colorLight: #5bf0fc;
$borderColor: #2e355b;
$hoverBgColor: rgba(91, 240, 252, 0.1);

.wl-left-aside {
    height: 100%;
    position: relative;
    // ::v-deep .curent-site-card {
    //   background-color: #071150;
    //   border: 1px solid #0b1b86;
    //   color: #ffffff;

    // }
    .card-title {
        color: #ffffff !important;
    }

    .site-item {
        border-radius: 2px 2px 2px 2px;

    }

    .is-active {
        background: linear-gradient(270deg, rgba(30, 118, 237, 0.5) 0%, rgba(30, 118, 237, 0.17) 34%, rgba(30, 118, 237, 0.17) 63%, rgba(30, 118, 237, 0.5) 100%);
        border: 1px solid #1E76ED;
    }

    .is-default {
        background: linear-gradient(270deg, rgba(81, 121, 158, 0.5) 0%, rgba(81, 121, 158, 0.17) 34%, rgba(81, 121, 158, 0.17) 63%, rgba(81, 121, 158, 0.5) 100%);
        border: 1px solid #51799E;
    }

}
</style>
